<template>
  <div id="app">
    <header>
      <md-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="showNavigation = true" v-if="showHamburgerMenu">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-title" v-on:click="goToHomepage">
          <img src="./assets/dsk.jpg" alt="Duta Sarana Konstruksi" style="width:50px;" :class="{dskLogoDesktop: !showHamburgerMenu}" v-if="!showHamburgerMenu">
          PT. Duta Sarana Konstruksi
        </span>

        <div class="md-toolbar-section-end" v-if="!showHamburgerMenu">
          <div v-on:click="goToHomepage" class="top-menu" :class="{topMenuSelected:(title == 'Homepage')}" v-if="!isOffice">Beranda</div>
          <div v-on:click="goToAbout" class="top-menu" :class="{topMenuSelected:(title == 'About')}" v-if="!isOffice">Tentang Kami</div>
          <!-- <div v-on:click="goToService" class="top-menu" :class="{topMenuSelected:(title == 'Service')}" v-if="!isOffice">Layanan</div> -->
          <div v-on:click="goToProjects" class="top-menu" :class="{topMenuSelected:(title == 'Projects')}" v-if="!isOffice">Portofolio</div>
          <div v-on:click="goToProducts" class="top-menu" :class="{topMenuSelected:(title == 'Products')}" v-if="!isOffice">Produk</div>
          <div v-on:click="goToContact" class="top-menu" :class="{topMenuSelected:(title == 'Contact')}" v-if="!isOffice">Hubungi Kami</div>

          <div v-on:click="goToLogout" class="top-menu" :class="{topMenuSelected:(title == 'Logout')}" v-if="isOffice">Keluar</div>
        </div>
      </md-toolbar>

      <md-drawer :md-active.sync="showNavigation" v-if="!isOffice">
        <md-toolbar class="md-transparent drawer-title" md-elevation="0">
          <span class="md-title">Duta Sarana Konstruksi</span>
        </md-toolbar>

        <md-list>
          <md-list-item v-on:click="goToHomepage">
            <md-icon>home</md-icon>
            <span class="md-list-item-text">Beranda</span>
          </md-list-item>

          <md-list-item v-on:click="goToAbout">
            <md-icon>chat_bubble_outline</md-icon>
            <span class="md-list-item-text">Tentang Kami</span>
          </md-list-item>

          <!-- <md-list-item v-on:click="goToService">
            <md-icon>send</md-icon>
            <span class="md-list-item-text">Layanan</span>
          </md-list-item> -->

          <md-list-item v-on:click="goToProjects">
            <md-icon>work_outline</md-icon>
            <span class="md-list-item-text">Portofolio</span>
          </md-list-item>

          <md-list-item v-on:click="goToProducts">
            <md-icon>widgets</md-icon>
            <span class="md-list-item-text">Produk</span>
          </md-list-item>

          <md-list-item v-on:click="goToContact">
            <md-icon>help_outline</md-icon>
            <span class="md-list-item-text">Hubungi Kami</span>
          </md-list-item>
        </md-list>
      </md-drawer>

      <md-drawer :md-active.sync="showNavigation" :md-permanent="type" v-if="isOffice" class="officeDrawer">
        <md-toolbar class="md-transparent drawer-title" md-elevation="0">
          <span class="md-title">Office Menu</span>
        </md-toolbar>

        <md-list>
          <md-list-item v-on:click="goToDashboard">
            <md-icon>dashboard</md-icon>
            <span class="md-list-item-text">Dashboard</span>
          </md-list-item>
          <md-list-item v-on:click="goToDProjects">
            <md-icon>work</md-icon>
            <span class="md-list-item-text">Portofolio</span>
          </md-list-item>
          <md-list-item v-on:click="goToDProducts">
            <md-icon>category</md-icon>
            <span class="md-list-item-text">Produk</span>
          </md-list-item>
          <md-list-item v-on:click="goToDClients">
            <md-icon>category</md-icon>
            <span class="md-list-item-text">Client</span>
          </md-list-item>
          <!-- <md-list-item v-on:click="goToAllContactForms">
            <md-icon>chat</md-icon>
            <span class="md-list-item-text">Hubungi Kami</span>
          </md-list-item>
          <md-list-item v-on:click="goToAllSubscribers">
            <md-icon>import_contacts</md-icon>
            <span class="md-list-item-text">Subscribers</span>
          </md-list-item>
          <md-list-item v-on:click="goToComposeEmail">
            <md-icon>email</md-icon>
            <span class="md-list-item-text">Kirim Email</span>
          </md-list-item> -->
          <md-list-item v-on:click="goToSettings">
            <md-icon>settings</md-icon>
            <span class="md-list-item-text">Pengaturan</span>
          </md-list-item>
          <md-list-item v-on:click="goToLogout">
            <md-icon>logout</md-icon>
            <span class="md-list-item-text">Keluar</span>
          </md-list-item>
        </md-list>
      </md-drawer>
    </header>
    <main :class="{needMarginLeft: (isOffice && !showHamburgerMenu)}" style="overflow:hidden;">
      <router-view></router-view>
    </main>
    <footer>
      <b-container fluid class="template">
        <b-row>
          <b-col lg="5" md="5" sm="12" xs="12" class="mb-5">
            <div class="mb-4">
              <h4>Tentang Kami</h4>
            </div>
            <div class="text-justify">
              {{aboutUsFooter}}
            </div>
          </b-col>
          <b-col lg="5" md="5" sm="12" xs="12" class="mb-5">
            <!-- <div class="mb-4">
              <h4>Buletin</h4>
            </div>
            <div class="mb-3">
              {{subscribeFooter}}
            </div>
            <div class="subscriberWrapper">
              <input id="emailField" type="email" placeholder="Enter email" v-model="subscribeEmail">
              <div class="subscribe" v-on:click="subscribe"><i class="material-icons">email</i></div>
            </div> -->
          </b-col>
          <b-col lg="2" md="2" sm="12" xs="12" class="mb-5">
            <div class="mb-4">
              <h4>Ikuti Kami</h4>
            </div>
            <div>
              {{socialMediaFooter}}
            </div>
            <div class="socialMedia">
              <img src="./assets/fb.png" alt="Facebook" class="fb">
              <img src="./assets/twitter.png" alt="Twitter" class="twitter">
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12" md="12" sm="12" xs="12">
            <div>
              Copyright &copy; 2024 All rights reserved.
            </div>
            <!-- <div>
              Powered by <a href="http://www.medevs.com" target="_blank" class="medevs">Medevs.com</a>
            </div> -->
          </b-col>
        </b-row>
      </b-container>
    </footer>
  </div>
</template>

<script>
// require('material-design-lite')
import {mapGetters} from 'vuex'

export default {
  name: 'app',
  data () {
    return {
      isLoading: false,
      subscribeEmail: '',
      showNavigation: false,
      windowWidth: 0,
      windowHeight: 0,
      email: '',
      type: 'full'
    }
  },
  methods: {
    findAllContents () {
      this.isLoading = true
      this.$store.dispatch('findAllContents', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get contents. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    },
    goToHomepage () {
      this.$router.push('/homepage')
      this.$data.showNavigation = false
    },
    goToAbout () {
      this.$router.push('/about')
      this.$data.showNavigation = false
    },
    goToService () {
      this.$router.push('/service')
      this.$data.showNavigation = false
    },
    goToProjects () {
      this.$router.push('/projects')
      this.$data.showNavigation = false
    },
    goToProducts () {
      this.$router.push('/products')
      this.$data.showNavigation = false
    },
    goToContact () {
      this.$router.push('/contact')
      this.$data.showNavigation = false
    },
    goToDashboard () {
      this.$router.push('/dashboard')
      this.$data.showNavigation = false
    },
    goToDClients () {
      this.$router.push('/dclients')
      this.$data.showNavigation = false
    },
    goToDProjects () {
      this.$router.push('/dprojects')
      this.$data.showNavigation = false
    },
    goToDProducts () {
      this.$router.push('/dproducts')
      this.$data.showNavigation = false
    },
    goToAllContactForms () {
      this.$router.push('/inquiries')
      this.$data.showNavigation = false
    },
    goToAllSubscribers () {
      this.$router.push('/subscribers')
      this.$data.showNavigation = false
    },
    goToComposeEmail () {
      this.$router.push('/composeemail')
      this.$data.showNavigation = false
    },
    goToSettings () {
      this.$router.push('/settings')
      this.$data.showNavigation = false
    },
    goToLogin () {
      this.$router.push('/login')
      this.$data.showNavigation = false
    },
    goToLogout () {
      this.$cookies.remove('uses')
      this.$cookies.remove('a')
      this.toast('Logged out succesfully.', 'success', 'check')
      this.$data.showNavigation = false
      this.$router.push('/homepage')
    },
    resetEmailForm () {
      this.$data.subscribeEmail = ''
    },
    validateEmailForm () {
      if (this.$data.subscribeEmail !== '' && this.$data.subscribeEmail !== undefined && this.$data.subscribeEmail.trim() !== '') {
        return true
      } else {
        return false
      }
    },
    subscribe () {
      if (this.validateEmailForm()) {
        this.$store.dispatch('subscribe', {
          data: {
            email: this.$data.subscribeEmail
          }
          // success: (res) => {
          //   console.log('success')
          //   this.toast(this.$data.email + ' subscribed!', 'success', 'check')
          //   this.resetEmailForm()
          // },
          // fail: (res) => {
          //   this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
          // }
        }).then(() => {
          this.isLoading = false
          this.toast(this.$data.subscribeEmail + ' subscribed!', 'success', 'check')
          this.resetEmailForm()
        }).catch(err => {
          console.error('error: ' + err)
        })
      } else {
        this.toast('Invalid email address.', 'error', 'error_outline')
      }
    },
    findContentById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    toast (msg, type, icon) {
      this.$toasted.show(msg, {
        theme: 'bubble',
        position: 'top-center',
        fullWidth: true,
        type: type,
        icon: icon,
        duration: 2000
      })
    }
  },
  computed: {
    ...mapGetters([
      'aboutUsFooter', 'subscribeFooter', 'socialMediaFooter'
    ]),
    title: function () {
      switch (this.$route.path) {
        case '/homepage':
          return 'Homepage'
        case '/about':
          return 'About'
        case '/service':
          return 'Service'
        case '/projects':
          return 'Projects'
        case '/products':
          return 'Products'
        case '/contact':
          return 'Contact'
        case '/dashboard':
          return 'Dashboard'
        case '/dclients':
          return 'Clients'
        case '/dprojects':
          return 'Projects'
        case '/dproducts':
          return 'Products'
        case '/settings':
          return 'Settings'
        case '/login':
          return 'Login'
        case '/logout':
          return 'Logout'
        default :
          return 'Homepage'
      }
    },
    showHamburgerMenu: function () {
      if (this.$data.windowWidth > 900) {
        return false
      } else {
        return true
      }
    },
    isOffice: function () {
      if (this.$route.path === '/dashboard' ||
          this.$route.path === '/dclients' ||
          this.$route.path === '/addclient' ||
          this.$route.path === '/dprojects' ||
          this.$route.path === '/addproject' ||
          this.$route.path === '/dproducts' ||
          this.$route.path === '/addproduct' ||
          this.$route.path.includes('/editproduct') ||
          this.$route.path === '/inquiries' ||
          this.$route.path === '/contactforms' ||
          this.$route.path === '/subscribers' ||
          this.$route.path === '/composeemail' ||
          this.$route.path === '/settings') {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      this.getWindowWidth()
      this.getWindowHeight()
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  },
  created () {
    this.findAllContents()
    // this.findContentById('aboutUsFooter')
    // this.findContentById('subscribeFooter')
    // this.findContentById('socialMediaFooter')
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');

/* @import url('https://code.getmdl.io/1.2.1/material.blue-red.min.css'); */

body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

main {
  text-align: center;
}

.primaryColor {
  color: #FF8F00;
}

header {
  margin: 0;
  height: 50px;
  /* background-color: #35495E; */
  background-color: #fff;
  color: #35495E;
}

header div {
  -webkit-box-shadow: none !important;
	-moz-box-shadow: none !important;
	box-shadow: none !important;
}

header .md-primary {
  border: 0px !important;
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
}

.dskLogoDesktop {
  width: 70px !important;
  margin-right: 10px;
}

.appName {
  font-weight: bold;
}

.md-elevation-4 {
  -webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
}

.md-toolbar {
  min-height: 50px;
}

.md-drawer {
  background-color: #fff;
  width: 280px !important;
}

.md-primary {
  border-bottom: 1px solid #ccc;
}

.top-menu {
  margin: 0px 15px;
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;
}

.topMenuSelected {
  border-bottom: 3px solid #FF8F00;
}

.drawer-title {
  background-color: #000;
  color: #fff;
}

footer {
  padding: 60px 40px;
  background-color: #000;
  color: #fff;
}

.socialMedia img {
  margin-right: 10px;
  cursor: pointer;
}

.fb {
  width: 20px;
  height: 20px;
}
.twitter {
  width: 23px;
  height: 23px;
}
.medevs {
  color: #FF8F00;
}
.medevs:hover {
  color: #fff;
}
.subscriberWrapper {
  background-color: #fff;
  overflow: hidden;
  position: relative;
	display: inline;
}
.subscriberWrapper input {
  border: none;
  padding: 10px 15px;
  width: 100%;
  outline: none;
  line-height: 1.5;
}
.subscribe {
  background-color: #FF8F00;
  position: absolute;
  top: -11px;
  bottom: -11px;
  right: 0px;
  font-size: 2em;
  padding: 0px 20px;
}
.subscribe:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
.needMarginLeft {
  margin-left: 280px;
}
.officeDrawer {
  border-right:1px solid #000;
  border-bottom:1px solid #000;
  background-color: #f3f3f3;
  min-height: 100vh;
}
.loadingOverlay {
  position: absolute;
  top: 20vh;
  left: 35%;
  content: url(assets/spinner.gif);
  width: 100px;
}
.even {
  background-color: #F5F5F5;
}
.generalBtn {
  background-color: #FF8F00;
  color: #FFF;
  padding: 5px 25px;
  margin-bottom: 10px;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.generalBtn:hover {
  background-color: #FFA000;
  color: #000;
  cursor: pointer;
}
.yesBtn {
  background-color: #FF8F00;
  color: #FFF;
  padding: 5px 25px;
  margin-bottom: 10px;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.yesBtn:hover {
  background-color: #FFA000;
  cursor: pointer;
}
.noBtn {
  background-color: #D84315;
  color: #FFF;
  padding: 5px 25px;
  margin-bottom: 10px;
  -webkit-transition: 300ms ease-in;
  -moz-transition: 300ms ease-in;
  -o-transition: 300ms ease-in;
  transition: 300ms ease-in;
}
.noBtn:hover {
  background-color: #E64A19;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue